import mutations from './mutations'
import actions from './actions'
import getters from './getters'


export default {
  namespaced: true,
  state: {
    selections: [],
    saleReport: {
      policyType: 'G'
    }
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/Dw/store/index.js